import { BookmakerLite } from "./components/products/positive-ev/positive-ev";
// import { Odds } from "./types/Odds";x


export function getImagePathByLeague(key: string): string {
    const bookmakerKeyPathMap = new Map<string, string >();
  
    bookmakerKeyPathMap.set("americanfootball_nfl", "");
    bookmakerKeyPathMap.set("americanfootball_ncaaf", "");
    bookmakerKeyPathMap.set("americanfootball_nfl_super_bowl_winner", "");
    bookmakerKeyPathMap.set("aussierules_afl", "");
    bookmakerKeyPathMap.set("baseball_mlb", "");
    bookmakerKeyPathMap.set("basketball_nba", "https://w7.pngwing.com/pngs/126/557/png-transparent-nba-logo-2005u201306-nba-season-orlando-magic-the-nba-finals-logo-nba-professional-basketball-logo-free-logo-design-template-text-wedding-logo-thumbnail.png");
    bookmakerKeyPathMap.set("cricket_test_match", "");
    bookmakerKeyPathMap.set("golf_masters_tournament_winner", "");
    bookmakerKeyPathMap.set("golf_the_open_championship_winner", "");
    bookmakerKeyPathMap.set("golf_us_open_winner", "");
    bookmakerKeyPathMap.set("icehockey_nhl", "");
    bookmakerKeyPathMap.set("icehockey_nhl_preseason", "");
    bookmakerKeyPathMap.set("icehockey_ahl", "");
    bookmakerKeyPathMap.set("mma_mixed_martial_arts", "");
    bookmakerKeyPathMap.set("boxing_boxing", "");
    bookmakerKeyPathMap.set("rugbyleague_nrl", "");
    bookmakerKeyPathMap.set("rugbyunion_six_nations", "");
    bookmakerKeyPathMap.set("soccer_australia_aleague", "");
    bookmakerKeyPathMap.set("soccer_brazil_campeonato", "");
    bookmakerKeyPathMap.set("handball_germany_bundesliga", "");
    bookmakerKeyPathMap.set("baseball_ncaa", "");
    bookmakerKeyPathMap.set("baseball_mlb_preseason", "");
    bookmakerKeyPathMap.set("basketball_wncaab", "");
    bookmakerKeyPathMap.set("basketball_nbl", "");
    bookmakerKeyPathMap.set("basketball_nba_preseason", "");
    bookmakerKeyPathMap.set("basketball_nba_summer_league", "");
    bookmakerKeyPathMap.set("americanfootball_nfl_preseason", "");
    bookmakerKeyPathMap.set("lacrosse_pll", "");
    bookmakerKeyPathMap.set("lacrosse_ncaa", "");
    return bookmakerKeyPathMap.get(key)||"";
}


export function getImagePathByTeamTitle(key: string): string {
    const bookmakerKeyPathMap = new Map<string, string >();
  
    bookmakerKeyPathMap.set("Boston Celtics", "");
    bookmakerKeyPathMap.set("Brooklyn Nets", "");
    bookmakerKeyPathMap.set("New York Knicks", "");
    bookmakerKeyPathMap.set("Philadelphia 76ers", "");
    bookmakerKeyPathMap.set("Toronto Raptors", "");
    bookmakerKeyPathMap.set("Chicago Bulls", "");
    bookmakerKeyPathMap.set("Cleveland Cavaliers", "");
    bookmakerKeyPathMap.set("Detroit Pistons", "");
    bookmakerKeyPathMap.set("Indiana Pacers", "");
    bookmakerKeyPathMap.set("Milwaukee Bucks", "");
    bookmakerKeyPathMap.set("Atlanta Hawks", "https://upload.wikimedia.org/wikipedia/en/thumb/2/24/Atlanta_Hawks_logo.svg/1200px-Atlanta_Hawks_logo.svg.png");
    bookmakerKeyPathMap.set("Charlotte Hornets", "");
    bookmakerKeyPathMap.set("Miami Heat", "");
    bookmakerKeyPathMap.set("Orlando Magic", "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Orlando_Magic_logo.svg/1200px-Orlando_Magic_logo.svg.png");
    bookmakerKeyPathMap.set("Washington Wizards", "");
    bookmakerKeyPathMap.set("Dallas Mavericks", "");
    bookmakerKeyPathMap.set("Houston Rockets", "");
    bookmakerKeyPathMap.set("Memphis Grizzlies", "");
    bookmakerKeyPathMap.set("New Orleans Pelicans", "");
    bookmakerKeyPathMap.set("San Antonio Spurs", "");
    bookmakerKeyPathMap.set("Denver Nuggets", "");
    bookmakerKeyPathMap.set("Minnesota Timberwolves", "");
    bookmakerKeyPathMap.set("Oklahoma City Thunder", "");
    bookmakerKeyPathMap.set("Portland Trail Blazers", "");
    bookmakerKeyPathMap.set("Utah Jazz", "");
    bookmakerKeyPathMap.set("Golden State Warriors", "");
    bookmakerKeyPathMap.set("Los Angeles Clippers", "");
    bookmakerKeyPathMap.set("Los Angeles Lakers", "");
    bookmakerKeyPathMap.set("Phoenix Suns", "");
    bookmakerKeyPathMap.set("Sacramento Kings", "");
  return bookmakerKeyPathMap.get(key)||"";
  }

  export function getDescriptionByComponent(key: string): string {
    const descrKeyMap = new Map<string, string >();
  
    descrKeyMap.set("BetFinder", "Experience the best real time betting options on live and upcoming games for all major sports. Includes odds on the latest Moneylines, Totals, and Spreads from the top US bookmakers!");
   //descrKeyMap.set("Brooklyn Nets", "");
    return descrKeyMap.get(key)||"";
}

  export function getIconPathBySportKey(key: string): string {
    // Tennis has 34 tournament-specific sport keys; route all tennis_* to one icon.
    if (key && key.startsWith("tennis_")) {
      return "/icons/sports/tennis.png";
    }
    const sportKeyToIconPathMap = new Map<string, string >();
    // Basketball family
    sportKeyToIconPathMap.set("basketball_nba", "/icons/sports/basketball.png");
    sportKeyToIconPathMap.set("basketball_nba_preseason", "/icons/sports/basketball.png");
    sportKeyToIconPathMap.set("basketball_nba_summer_league", "/icons/sports/basketball.png");
    sportKeyToIconPathMap.set("basketball_ncaab", "/icons/sports/basketball.png");
    sportKeyToIconPathMap.set("basketball_wncaab", "/icons/sports/basketball.png");
    sportKeyToIconPathMap.set("basketball_wnba", "/icons/sports/basketball.png");
    sportKeyToIconPathMap.set("basketball_nbl", "/icons/sports/basketball.png");
    sportKeyToIconPathMap.set("basketball_euroleague", "/icons/sports/basketball.png");

    // Hockey family
    sportKeyToIconPathMap.set("icehockey_nhl", "/icons/sports/hockey.png");
    sportKeyToIconPathMap.set("icehockey_nhl_preseason", "/icons/sports/hockey.png");
    sportKeyToIconPathMap.set("icehockey_ahl", "/icons/sports/hockey.png");

    // Combat sports and other new leagues — icons to be added to
    // /public/icons/sports/; returning "" falls back to no icon for now.
    sportKeyToIconPathMap.set("mma_mixed_martial_arts", "");
    sportKeyToIconPathMap.set("boxing_boxing", "");
    sportKeyToIconPathMap.set("handball_germany_bundesliga", "");
    sportKeyToIconPathMap.set("baseball_ncaa", "");
    sportKeyToIconPathMap.set("baseball_mlb_preseason", "");
    sportKeyToIconPathMap.set("lacrosse_pll", "");
    sportKeyToIconPathMap.set("lacrosse_ncaa", "");
    sportKeyToIconPathMap.set("rugbyunion_six_nations", "");
    sportKeyToIconPathMap.set("americanfootball_nfl_preseason", "");

    return sportKeyToIconPathMap.get(key)||"";
  }

  
  export type SourceType = "sportsbook" | "dfs" | "exchange" | "prediction_market";

  export interface BookmakerLiteWithSource extends BookmakerLite {
    sourceType: SourceType;
  }

  export const SOURCE_TYPE_LABELS: Record<SourceType, string> = {
    sportsbook: "Sportsbooks",
    dfs: "DFS / Pick'em",
    exchange: "Exchanges",
    prediction_market: "Prediction Markets",
  };

  export const defaultBookmakers: BookmakerLite[] = [
    { key: "betmgm", title: "BetMGM" },
    { key: "betonlineag", title: "BetOnline.ag" },
    { key: "betrivers", title: "BetRivers" },
    { key: "betus", title: "BetUS" },
    { key: "bovada", title: "Bovada" },
    { key: "draftkings", title: "DraftKings" },
    { key: "fanduel", title: "FanDuel" },
    { key: "lowvig", title: "LowVig.ag" },
    { key: "mybookieag", title: "MyBookie.ag" },
    { key: "williamhill_us", title: "Caesars" },
    { key: "espnbet", title: "theScore Bet" },
    { key: "ballybet", title: "Bally Bet" },
    { key: "betparx", title: "BetParx" },
    { key: "fliff", title: "Fliff" },
    { key: "hardrockbet", title: "Hard Rock Bet" },
    { key: "windcreek", title: "Wind Creek" },
    { key: "fanatics", title: "Fanatics Sportsbook" },
    { key: "betanysports", title: "BetAnySports" },
    // DFS / Pick'em
    { key: "prizepicks", title: "PrizePicks" },
    { key: "underdog", title: "Underdog Fantasy" },
    { key: "pick6", title: "DraftKings Pick6" },
    { key: "betr_us_dfs", title: "Betr Picks" },
    { key: "dabble_us_dfs", title: "Dabble Pick'em" },
    // Exchanges
    { key: "novig", title: "Novig" },
    { key: "prophetx", title: "ProphetX" },
    { key: "betopenly", title: "BetOpenly" },
    { key: "matchbook", title: "Matchbook" },
    // Prediction Markets
    { key: "kalshi", title: "Kalshi" },
    { key: "polymarket", title: "Polymarket" },
    // AU Sportsbooks
    { key: "dabble_au", title: "Dabble" },
  ];

  export const allBookmakersWithSource: BookmakerLiteWithSource[] = [
    // Sportsbooks
    { key: "betmgm", title: "BetMGM", sourceType: "sportsbook" },
    { key: "betonlineag", title: "BetOnline.ag", sourceType: "sportsbook" },
    { key: "betrivers", title: "BetRivers", sourceType: "sportsbook" },
    { key: "betus", title: "BetUS", sourceType: "sportsbook" },
    { key: "bovada", title: "Bovada", sourceType: "sportsbook" },
    { key: "draftkings", title: "DraftKings", sourceType: "sportsbook" },
    { key: "fanduel", title: "FanDuel", sourceType: "sportsbook" },
    { key: "lowvig", title: "LowVig.ag", sourceType: "sportsbook" },
    { key: "mybookieag", title: "MyBookie.ag", sourceType: "sportsbook" },
    { key: "williamhill_us", title: "Caesars", sourceType: "sportsbook" },
    { key: "espnbet", title: "theScore Bet", sourceType: "sportsbook" },
    { key: "ballybet", title: "Bally Bet", sourceType: "sportsbook" },
    { key: "betparx", title: "BetParx", sourceType: "sportsbook" },
    { key: "fliff", title: "Fliff", sourceType: "sportsbook" },
    { key: "hardrockbet", title: "Hard Rock Bet", sourceType: "sportsbook" },
    { key: "fanatics", title: "Fanatics Sportsbook", sourceType: "sportsbook" },
    { key: "betanysports", title: "BetAnySports", sourceType: "sportsbook" },
    // DFS / Pick'em
    { key: "prizepicks", title: "PrizePicks", sourceType: "dfs" },
    { key: "underdog", title: "Underdog Fantasy", sourceType: "dfs" },
    { key: "pick6", title: "DraftKings Pick6", sourceType: "dfs" },
    { key: "betr_us_dfs", title: "Betr Picks", sourceType: "dfs" },
    { key: "dabble_us_dfs", title: "Dabble Pick'em", sourceType: "dfs" },
    // Exchanges
    { key: "novig", title: "Novig", sourceType: "exchange" },
    { key: "prophetx", title: "ProphetX", sourceType: "exchange" },
    { key: "betopenly", title: "BetOpenly", sourceType: "exchange" },
    { key: "matchbook", title: "Matchbook", sourceType: "exchange" },
    // Prediction Markets
    { key: "kalshi", title: "Kalshi", sourceType: "prediction_market" },
    { key: "polymarket", title: "Polymarket", sourceType: "prediction_market" },
    // AU Sportsbooks
    { key: "dabble_au", title: "Dabble", sourceType: "sportsbook" },
  ];

